<template>
  <div>
    <px-view-header title="Gestão de entregas" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <div>
      <px-gestao-entrega-lista />
    </div>
  </div>
</template>

<script>
import GestaoEntregaLista from '@/modules/entregas/GestaoEntregaLista.vue';

export default {
  data() {
    return {
      breadcrumbs: [
        { text: 'Gestão de compras' },
        { text: 'Entregas' },
      ],
    };
  },
  components: {
    pxGestaoEntregaLista: GestaoEntregaLista,
  },
};
</script>
